import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _get from 'lodash/get';
import { ColumnConfig, CellConfig } from '../../../molecules/tableInputField';
import { getCellError } from '../../../molecules/tableInputField/utils/general';
import SelectInputCellRenderer from '../../../molecules/tableInputField/cellRenderers/SelectInputCellRenderer';
import { getSingleValueStyles, getInputStylesInRem } from '../../../molecules/advancedSelect/styles/AdvancedSelect.styles';
import { OVERRIDE_MODAL_ZINDEX, FIELD_IDS } from '../multiSort.constants';
import styles from '../multiSort.module.scss';
var getMenuPortalStyle = function getMenuPortalStyle(base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    zIndex: OVERRIDE_MODAL_ZINDEX
  });
};
var getProps = function getProps(props) {
  return {
    placeHolder: __('Select'),
    menuPosition: 'fixed',
    autoFocus: true,
    options: _get(props, "tdProps.rest.additional.sortableColumns.".concat(props.index)),
    styleOverrides: {
      menuPortal: getMenuPortalStyle,
      input: getInputStylesInRem,
      singleValue: getSingleValueStyles
    },
    headerClassName: styles.columnHeader,
    error: getCellError(props)
  };
};
var setGetValueFromOnChange = function setGetValueFromOnChange(_nestingPath, params) {
  return _get(params, 'value');
};
var SORT_ORDER_FIELD = new ColumnConfig(FIELD_IDS.SORT_FIELD).setAccessor(FIELD_IDS.SORT_FIELD).addCellConfig(new CellConfig().setComponent(SelectInputCellRenderer)).setGetValueFromOnChange(setGetValueFromOnChange).setMapCellPropsToComponentProps(getProps).setMinWidth(180).setHeaderClassName(styles.columnHeader);
export default SORT_ORDER_FIELD;